export enum FilterCategory {
  None = '',
  Individual = '1',
  All = '2',
}
